import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';
import KeenSlider from 'keen-slider';

export default class ThemePopupGalleryGrid {

    constructor(dom) {

        // Vars
        // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
        this.NAME = `ThemePopupGalleryGrid`;

        this.dom = dom;

        this.gridItemDoms = this.dom.querySelectorAll(`[data-theme-popup-gallery-grid-item]`);
        this.gridItemOpenActionDoms = this.dom.querySelectorAll(`[data-theme-popup-gallery-grid-item-open-action]`);

        this.overlayDoms = this.dom.querySelectorAll(`[data-theme-popup-gallery-grid-overlay]`);
        this.overlayCloseButtonDoms = this.dom.querySelectorAll(`[data-theme-popup-gallery-grid-overlay-close-button]`);
        this.overlayActiveClass = `theme-popup-gallery-grid-overlay--active`;
        this.overlayThumbnailDoms = this.dom.querySelectorAll(`[data-theme-popup-gallery-grid-overlay-thumbnail]`);
        this.overlayArrowBtnDoms = this.dom.querySelectorAll(`[data-theme-popup-gallery-btn]`);
        this.overlayThumbnailDomActiveClass = `theme-popup-gallery-grid-overlay__thumbnail--active`;

        this.slider;
    }

    // Logic
    // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
    init() {
        Logger.info(`${this.NAME} > init`);

        const self = this;

        this.initCloseButtons();
        this.initGridItems();
        this.initOverlayThumbnails();
        this.initOverlayArrowBtns();
    }

    /**
     * closeAllOverlays - Close any open overlays
     */
    closeAllOverlays(instant) {
        Logger.info(`${this.NAME} > closeAllOverlays`);

        this.overlayDoms.forEach((overlay) => {
            overlay.classList.remove(this.overlayActiveClass);
        });

        // Destroy the slider
        if (this.slider) {
            this.slider.destroy();
            this.slider = null;
        }

        // Allow the body to scroll again
        const scrollY = document.body.style.top;
        document.body.style.paddingRight = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        document.body.style.zIndex = '';
        if (instant) {
            window.scrollTo({top: parseInt(scrollY || '0') * -1, behavior: 'instant'});
        } else {
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }

        document.body.removeEventListener('keydown', this.handleEscKey.bind(this));
    }

    /**
     * handleEscKey - Enable the escape key to close the meganav
     */
    handleEscKey(e) {
        Logger.info(`${this.NAME} > handleEscKey`);
        if (e.key === "Escape") {
            this.closeAllOverlays(true);
        }
    }

    /**
     * initCloseButtons - Initialize all close buttons
     */
    initCloseButtons() {
        Logger.info(`${this.NAME} > initCloseButtons`);

        const self = this;

        this.overlayCloseButtonDoms.forEach((button) => {
            console.log(button)
            button.addEventListener('click', (e) => {
                console.log(e);
                e.preventDefault();
                self.closeAllOverlays(true);
            });
        });
    }

    /**
     * initGridItems - Initialize the main grid items
     */
    initGridItems() {
        Logger.info(`${this.NAME} > initGridItems`);

        const self = this;

        this.gridItemOpenActionDoms.forEach((openAction) => {
            openAction.addEventListener('click', (e) => {
                e.preventDefault();
                const gridItem = openAction.closest(`[data-theme-popup-gallery-grid-item]`);
                self.showOverlayForGridItem(gridItem);
            });
        });
    }

    /**
     * initOverlayThumbnails - Initialize all overlay thumbnails
     */
    initOverlayThumbnails() {
        Logger.info(`${this.NAME} > initOverlayThumbnails`);

        const self = this;

        // Initialize all dots for clicking
        this.overlayThumbnailDoms.forEach((thumbnailDom) => {
            thumbnailDom.addEventListener('click', (e) => {
                e.preventDefault();

                if (!self.slider) return;

                const idx = thumbnailDom.getAttribute(`data-theme-popup-gallery-grid-overlay-thumbnail`);
                self.slider.moveToIdx(parseInt(idx));
            });
        });
    }

    initOverlayArrowBtns() {
        Logger.info(`${this.NAME} > initOverlayArrowBtns`);

        const self = this;

        // Initialize all dots for clicking
        this.overlayArrowBtnDoms.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                if (!self.slider) return;
                if (btn.dataset.dir == 'right') {
                    self.slider.next();
                } else {
                    self.slider.prev();
                }
            });
        });
    }

    /**
     * showOverlayForGridItem - The the overlay for a specific grid item
     */
    showOverlayForGridItem(gridItem) {
        Logger.info(`${this.NAME} > showOverlayForGridItem`);

        const self = this;

        this.closeAllOverlays();

        const overlay = gridItem.querySelector(`[data-theme-popup-gallery-grid-overlay]`);

        if (!overlay) return;

        overlay.classList.add(this.overlayActiveClass);


        /**
         * Setup the slider
         */

        if (this.slider) return;

        const slidesContainerDom = overlay.querySelector(`[data-theme-popup-gallery-grid-overlay-slides]`);

        this.slider = new KeenSlider(
            slidesContainerDom,
            {
                selector: '.theme-popup-gallery-grid-overlay__slide',
                loop: true
            },
            [
                (slider) => {

                    // When an animation has started
                    slider.on('animationStarted', () => {
                        Logger.info(`${this.NAME} > showOverlayForGridItem > animationStarted`);

                        const slides = self.dom.querySelectorAll(`.theme-popup-gallery-grid-overlay__slide`);
                        slides.forEach((slide) => {
                            slide.classList.add('theme-popup-gallery-grid-overlay__slide--preview-image');
                        });
                    });

                    // After slider is created
                    slider.on('created', () => {
                        Logger.info(`${this.NAME} > showOverlayForGridItem > created`);
                        self.updateClasses(slider);
                    });

                    // After a slide has changed
                    slider.on('slideChanged', () => {
                        Logger.info(`${this.NAME} > showOverlayForGridItem > slideChanged`);
                        self.updateClasses(slider);
                    });
                }
            ]
        );

        // When the meganav is show, we need to fix the body
        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.paddingRight = '15px';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.zIndex = '0';

        document.body.addEventListener('keydown', this.handleEscKey.bind(this));
    }

    /**
     * updateClasses - Update all classes according to the slider's state
     */
    updateClasses(slider) {
        Logger.info(`${this.NAME} > updateClasses`, slider);

        const self = this;

        if (!slider) return;

        const idx = slider.track.details.rel;

        self.overlayThumbnailDoms.forEach((overlayThumbnailDom) => {
            if (parseInt(overlayThumbnailDom.getAttribute(`data-theme-popup-gallery-grid-overlay-thumbnail`)) == idx) {
                overlayThumbnailDom.classList.add(self.overlayThumbnailDomActiveClass);
            } else {
                overlayThumbnailDom.classList.remove(self.overlayThumbnailDomActiveClass);
            }
        });

        // Remove the preview image
        setTimeout(() => {
            const slides = self.dom.querySelectorAll(`.theme-popup-gallery-grid-overlay__slide`);
            slides.forEach((slide) => {
                slide.classList.remove('theme-popup-gallery-grid-overlay__slide--preview-image');
            });
        }, 1000);
    }
}

// Mixins
Object.assign(ThemePopupGalleryGrid.prototype, eventMixin);
